// Каждая тема полностью описывает свои цвета включая background, paper, divider, action.hover.
// Это гарантирует что при смене темы не остаётся "чужих" цветов из базовой темы.

const LightThemeColors = [
  {
    name: 'GREEN_THEME',
    palette: {
      primary: {
        main: '#44A437',
        light: '#E5F7E1',
        dark: '#2E7025',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#6DC860',
        light: '#C9EEC4',
        dark: '#378E2B',
        contrastText: '#ffffff',
      },
      // Тёплые фоны — только для GREEN_THEME
      background: {
        default: '#ffffff',   // тёплый жёлто-зелёный фон приложения
        paper: '#ffffff',   // тёплый жёлто-зелёный paper (карточки, AppBar)
      },
      divider: '#D4EDD0',
      action: {
        hover: '#EEF8E6',     // hover строк таблицы, фон инпутов
      },
      text: {
        primary: '#1C2B1C',
        secondary: '#4E6B4D',
      },
    },
  },
  {
    name: 'BLUE_THEME',
    palette: {
      primary: {
        main: '#1976D2',
        light: '#E3F2FD',
        dark: '#1565C0',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#42A5F5',
        light: '#E3F2FD',
        dark: '#1E88E5',
        contrastText: '#ffffff',
      },
      background: {
        default: '#F0F6FF',
        paper: '#ffffff',
      },
      divider: '#DDEEFF',
      action: {
        hover: '#EBF4FF',
      },
      text: {
        primary: '#1A2B3C',
        secondary: '#4A6080',
      },
    },
  },
  {
    name: 'AQUA_THEME', // выбранная тема
    palette: {
      primary: {
        main: '#041ee9',
        light: '#EFF9FF',
        dark: '#5b6cee',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#47D7BC',
        light: '#EDFBF7',
        dark: '#39C7AD',
        contrastText: '#ffffff',
      },
      background: {
        default: '#f8feff', // фон сайта
        paper: '#ffffff',
      },
      divider: '#C8EAF5',
      action: {
        hover: '#E5F5FC',
      },
    },
  },
  {
    name: 'PURPLE_THEME',
    palette: {
      primary: {
        main: '#763EBD',
        light: '#F2ECF9',
        dark: '#6E35B7',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#95CFD5',
        light: '#EDF8FA',
        dark: '#8BC8CE',
        contrastText: '#ffffff',
      },
      background: {
        default: '#F7F2FC',
        paper: '#ffffff',
      },
      divider: '#E0D0F5',
      action: {
        hover: '#F0E8FA',
      },
    },
  },
  {
    name: 'ORANGE_THEME',
    palette: {
      primary: {
        main: '#E64A19',
        light: '#FBF2EF',
        dark: '#BF360C',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#0074BA',
        light: '#EFF9FF',
        dark: '#006FB1',
        contrastText: '#ffffff',
      },
      background: {
        default: '#FDF5F2',
        paper: '#ffffff',
      },
      divider: '#F5D8CF',
      action: {
        hover: '#FAEAE5',
      },
    },
  },
  {
    name: 'CYAN_THEME',
    palette: {
      primary: {
        main: '#01C0C8',
        light: '#EBF9FA',
        dark: '#00B9C0',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#FB9678',
        light: '#FFF5F2',
        dark: '#F48B6C',
        contrastText: '#ffffff',
      },
      background: {
        default: '#F0FAFB',
        paper: '#ffffff',
      },
      divider: '#C0EEF0',
      action: {
        hover: '#E3F8F9',
      },
    },
  },
];

export { LightThemeColors };